import React, { useState, useEffect } from 'react';

import ReactLightbox from 'react-image-lightbox';

import 'react-image-lightbox/style.css';
import type { Medium } from 'src/types/__generated__/graphql';

import type { ModalProps } from 'src/hooks/useModalOpenState';

interface Props extends ModalProps {
    images?: Array<Medium | null>;
    imagesUrls?: Array<string | null>;
    enableZoom?: boolean;
    mainImageUrl?: string;
}

const Lightbox: React.FC<Props> = ({ open, onClose, mainImageUrl, images, imagesUrls, enableZoom = false }) => {
    const [photoIndex, setPhotoIndex] = useState<number | undefined>(undefined);

    const selectImage = () => {
        if (mainImageUrl) {
            let index = -1;
            if (images) {
                index = images.findIndex((img) => (img ? img.url === mainImageUrl : false));
            } else if (imagesUrls) {
                index = imagesUrls.findIndex((img) => (img ? img === mainImageUrl : false));
            }
            if (index >= 0) {
                setPhotoIndex(index);
            } else {
                setPhotoIndex(0);
            }
        } else {
            setPhotoIndex(0);
        }
    };

    useEffect(() => {
        if (open) {
            selectImage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const close = () => {
        setPhotoIndex(undefined);
        onClose();
    };

    const handleMoveNext = () => {
        let nextIndex: number | undefined;

        if (photoIndex !== undefined) {
            if (images?.length) {
                nextIndex = (photoIndex + 1) % images.length;
            } else if (imagesUrls?.length) {
                nextIndex = (photoIndex + 1) % imagesUrls.length;
            }

            setPhotoIndex(nextIndex);
        }
    };

    const handleMovePrev = () => {
        let prevIndex: number | undefined;

        if (photoIndex !== undefined) {
            if (images?.length) {
                prevIndex = (photoIndex + images.length - 1) % images.length;
            } else if (imagesUrls?.length) {
                prevIndex = (photoIndex + imagesUrls.length - 1) % imagesUrls.length;
            }

            setPhotoIndex(prevIndex);
        }
    };

    let mainSrc = '';
    let nextSrc: string | undefined;
    let prevSrc: string | undefined;
    if (photoIndex !== undefined) {
        if (images?.length) {
            mainSrc = images[photoIndex]?.url ?? '';
            nextSrc = images.length > 1 ? images[(photoIndex + 1) % images.length]?.url : undefined;
            prevSrc = images.length > 1 ? images[(photoIndex + images.length - 1) % images.length]?.url : undefined;
        } else if (imagesUrls?.length) {
            mainSrc = imagesUrls[photoIndex] ?? '';
            nextSrc = imagesUrls.length > 1 ? imagesUrls[(photoIndex + 1) % imagesUrls.length] ?? undefined : undefined;
            prevSrc =
                imagesUrls.length > 1
                    ? imagesUrls[(photoIndex + imagesUrls.length - 1) % imagesUrls.length] ?? undefined
                    : undefined;
        }
    }

    return (
        <>
            {/* {trigger(open)} */}
            {typeof photoIndex !== 'undefined' && (
                <ReactLightbox
                    mainSrc={mainSrc}
                    nextSrc={nextSrc}
                    prevSrc={prevSrc}
                    onCloseRequest={close}
                    onMovePrevRequest={handleMovePrev}
                    onMoveNextRequest={handleMoveNext}
                    enableZoom={enableZoom}
                />
            )}
        </>
    );
};

export default Lightbox;
